import React from "react";
import Header from "../../components/header/Header";
import ProjectCard from "../../components/project-card/ProjectCard";
import { projectData } from "../../data/projectData";

const Projects = () => {
    return (
        <div className="my-8" id="projects">
            <Header text="Projects"></Header>
            <div className="my-8 grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-6 place-items-center">
                {projectData.map((item) => (
                    <ProjectCard item={item} key={item.id} />
                ))}
            </div>
        </div>
    );
};

export default Projects;
